import { FC, ReactEventHandler, useEffect, useState } from 'react';
import { ICampusItem, ICampusGroup } from '../models/campuses.model';
import { Select } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../store/rootReducer';
import { setCurrentCampus } from '../store/auth.slice';
import { campusHeadOffice } from '../lib/data';
import { useTranslation } from 'react-i18next';
import { getCampusGroup } from '../lib/util';

interface IProps {
  hasHq?: boolean;
  disabled?: boolean;
  normalOnly?: boolean;
  hasAll?: boolean;
  className?: string;
  placeholder?: string;
  value?: string | null;
  onChange?: any;
  additionalCampus?: string[]
}

const SelectCampus: FC<IProps> = ({
  hasHq = true,
  disabled = false,
  normalOnly = false,
  hasAll = false,
  value,
  className,
  placeholder,
  onChange,
  additionalCampus,
}) => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const { auth, currentCampus } = useSelector((state: RootState) => state.auth);
  const { campusData } = useSelector((state: RootState) => state.campusData);
  const [campusGroups, setCampusGroups] = useState<ICampusGroup[]>([]);

  useEffect(() => {
    if (auth && campusData) {
      let campuses: ICampusItem[] = [];

      if (auth.hqYn ==='Y') {
        campuses = campusData;
      } else {
        auth.campus.forEach(item => {
          const campusItem = campusData.find(subitem => subitem.campusCode === item);
          if (campusItem) campuses.push(campusItem);

          if (additionalCampus) {
            const _additionalCampus = campusData.find(subitem => additionalCampus.includes(subitem.campusCode));

            if (_additionalCampus) campuses.push(_additionalCampus);
          }
        });
      }

      if (!hasHq) {
        campuses = campuses.filter(item => item.campusCode !== campusHeadOffice);
      }

      if (normalOnly) {
        campuses = campuses.filter(item => item.campusStatus === 'NM');
      }
      
      setCampusGroups(
        getCampusGroup(campuses, campusHeadOffice)
      );
    }
  }, [auth, campusData]);

  useEffect(() => {
    if (currentCampus === campusHeadOffice && !hasHq) {
      dispatch(setCurrentCampus(''));
    }
  }, [currentCampus]);

  const _onChange = (campusCode: string) => {
    if(campusCode !== '') {
      localStorage.setItem('currentCampus', campusCode);
      dispatch(setCurrentCampus(campusCode));  
    }
    
  }
  
  return (
    <Select
      className={className || 'w-150'}
      placeholder={placeholder || t('class.class.placeholder1')}
      value={value ?? currentCampus} 
      onChange={onChange || _onChange}
      disabled={disabled}
      listHeight={320}
    >
      {hasAll && (
        <Select.Option value="">
          {t('common.text.all')}
        </Select.Option>
      )}

      {campusGroups.map(campusGroup=> (
        <Select.OptGroup
          key={`campus-group-key-${campusGroup.isTestCampus}`}
          label={ 
            t( campusGroup.isTestCampus
              ? 'campus.group.text2'
              : 'campus.group.text1'
            ) 
          }
        >
          {campusGroup.campuses.map((item: ICampusItem, index: number) => (
            <Select.Option
              key={item.campusCode || `select-campus-key-${index}`}
              value={item.campusCode}
            >
              {i18n.language === 'ko' ? item.campusKorName : item.campusEngName}
            </Select.Option>
          ))}
        </Select.OptGroup>
      ))}

      
    </Select>
  )
}

export default SelectCampus;
